import { render, staticRenderFns } from "./EditarEnvioImagen.vue?vue&type=template&id=53b5c22c"
import script from "./EditarEnvioImagen.vue?vue&type=script&lang=js"
export * from "./EditarEnvioImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports